import React from "react";
import styled from "styled-components";
import TextRenderer from "./TextRenderer";

const Style = styled.div`
    display: flex;
    flex-direction: column;
    position: relative;
    padding: 0rem 70px 1rem;
    width: calc(100% - 140px);
    .data {
        position: relative;
        margin-top: -4rem;
        /* margin-bottom: -4rem; */
        /* top: -4rem; */
        z-index: 5;
        background-color: #f5faff;
        box-shadow: var(--n-shadow-1);
        padding: 2rem;
        border-radius: 8px;
        display: flex;
        flex-direction: column;
    }
    @media (max-width: 850px){
        padding: 0rem 16px 1rem;
        width: calc(100% - 32px);
        .data {
            padding: 2rem 1rem;
        }
    }
`;

export default function TextPage({data}) {
    return (
      <Style>
        <div className="data">
            <TextRenderer data={data.data}/>
        </div>
      </Style>
  );
}
